import { render } from "./PrefixReferencedDois.vue?vue&type=template&id=0a27f80c&scoped=true"
import script from "./PrefixReferencedDois.vue?vue&type=script&lang=js"
export * from "./PrefixReferencedDois.vue?vue&type=script&lang=js"

import "./PrefixReferencedDois.vue?vue&type=style&index=0&id=0a27f80c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a27f80c"]])

export default __exports__